import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { deleteConditionAction, removeMediaElementAction, removeSlotLayoutAction } from 'editor/src/store/design/slice';
import { getSlotLayoutElements } from 'editor/src/store/design/util/slotLayout/slotLayoutElements';
import saveUndoRedoStateOperation from 'editor/src/store/editorModules/undoRedo/operation/saveUndoRedoStateOperation';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import updateHiddenElementsOperation from './updateHiddenElementsOperation';

/** Takes the layout off the page with everything it manages: its layers and its picklists. */
const removeSlotLayoutOperation =
  (spreadIndex: number, layoutId: string) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    const spread = getState().design.designData?.spreads[spreadIndex];
    const layout = spread?.slotLayouts?.find((item) => item.id === layoutId);
    if (!spread || !layout) {
      return;
    }

    batch(() => {
      dispatch(saveUndoRedoStateOperation('Remove product layout'));
      getSlotLayoutElements(spread, spreadIndex, layoutId)
        .sort((a, b) => b.address.elementIndex - a.address.elementIndex)
        .forEach(({ address }) => dispatch(removeMediaElementAction(address)));

      const conditions = getState().design.designData?.spreads[spreadIndex]?.conditionGroup?.conditions ?? {};
      // Product picklists first: deleting the count picklist would otherwise lift them to the
      // top level instead of taking them along.
      [...layout.productConditionIds, layout.conditionId].forEach((conditionId) => {
        if (conditions[conditionId]) {
          dispatch(deleteConditionAction({ spreadIndex, conditionId }));
        }
      });

      dispatch(removeSlotLayoutAction({ spreadIndex, layoutId }));
      dispatch(updateHiddenElementsOperation(spreadIndex));
    });
  };

export default removeSlotLayoutOperation;
